import api from '../../utils/api';

export default {
  fetch: () => api.makeEndpoint('get', `catalog/types`),
};
